export enum ConfigurationType {
  BASE = 'BASE',
  BASEANNI = 'BASEANNI',
  BASEMAG = 'BASEMAG',
  BASERESMI = 'BASERESMI',
  BASE14 = 'BASE14',
  BASE02 = 'BASE02',
  BASE02A = 'BASE02A',
  BASE02DEC = 'BASE02DEC',
  BASEG = 'BASEG',
  BASEDIR = 'BASEDIR',
  BASESD = 'BASESD',
  BASETRASC = 'BASETRASC',
  BASEFOPFI = 'BASEFOPFI',
  BASEOPFI = 'BASEOPFI',
  BASERIC = 'BASERIC',
  BASERICAU = 'BASERICAU',
  BASERICNSE = 'BASERICNSE',
  BASEMIN = 'BASEMIN',
  BASESCATTO = 'BASESCATTO',
  BASEM = 'BASEM',
  BASEP = 'BASEP',
  BASEDECA = 'BASEDECA',
  BASEDECO = 'BASEDECO',
  BASEDECOV = 'BASEDECOV',
  BASEDEC = 'BASEDEC',
  BASECONI = 'BASECONI',
  BASEDECNID = 'BASEDECNID',
  BASECIT06 = 'BASECIT06',
  BASECIT07 = 'BASECIT07',
  BASEUC = 'BASEUC',
  BASEPERD = 'BASEPERD',
  BASE02OPFI = 'BASE02OPFI',
  BASENOINT = 'BASENOINT',
  BASENOINTR = 'BASENOINTR',
  BASENOINTP = 'BASENOINTP',
  BASEAVV = 'BASEAVV',
  BASEAVV2 = 'BASEAVV2',
  BASEAVV3 = 'BASEAVV3',
  BASEAVV4 = 'BASEAVV4',
  BASEUCST = 'BASEUCST',
  BASEMTST = 'BASEMTST',
  BASEANMD = 'BASEANMD',
  FIGLIOTRNA = 'FIGLIOTRNA',
  SOGMIN = 'SOGMIN',
  SOGMINA = 'SOGMINA',
  RICH_UCOPF = 'RICH_UCOPF',
  TRASDATIAT = 'TRASDATIAT',
  RICDGCSAS = 'RICDGCSAS',
  RICDGCSSE = 'RICDGCSSE',
  RICDGCS = 'RICDGCS',
  RICDGAS = 'RICDGAS',
  RICDGP = 'RICDGP',
  RICCONS = 'RICCONS',
  RICASSE = 'RICASSE',
  RICDGCSASC = 'RICDGCSASC',
  TRAEDATIAT = 'TRAEDATIAT',
  TRASDATIAU = 'TRASDATIAU',
  TRASDATIAF = 'TRASDATIAF',
  AUMITITA = 'AUMITITA',
  TRASDATIAV = 'TRASDATIAV',
  TRAEDATIAU = 'TRAEDATIAU',
  ENTEDICHAC = 'ENTEDICHAC',
  TRATXTBASE = 'TRATXTBASE',
  TRANEGASS = 'TRANEGASS',
  TRATXTBASI = 'TRATXTBASI',
  TRATXTBASG = 'TRATXTBASG',
  TRATXTBASN = 'TRATXTBASN',
  TRATXBASRP = 'TRATXBASRP',
  TRATXTBASV = 'TRATXTBASV',
  TRATXTTISC = 'TRATXTTISC',
  TRATXBASF = 'TRATXBASF',
  TRATXTSCR = 'TRATXTSCR',
  TRASCRTISC = 'TRASCRTISC',
  TRATXTBASC = 'TRATXTBASC',
  TRASTXTRIC = 'TRASTXTRIC',
  TRATXBASR = 'TRATXBASR',
  TRATXBASRN = 'TRATXBASRN',
  TRATXBASRQ = 'TRATXBASRQ',
  TRATXBASRX = 'TRATXBASRX',
  TRATXBASRO = 'TRATXBASRO',
  TRATXTBASF = 'TRATXTBASF',
  TRATXTUCE = 'TRATXTUCE',
  TRATXTUC3 = 'TRATXTUC3',
  TRATXTUC2 = 'TRATXTUC2',
  TRATXTMTE = 'TRATXTMTE',
  TRATXTMTAE = 'TRATXTMTAE',
  TRATXTUCSI = 'TRATXTUCSI',
  TRATXTBSDE = 'TRATXTBSDE',
  TRATXTBSDF = 'TRATXTBSDF',
  TRASNASLU = 'TRASNASLU',
  NASC01 = 'NASC01',
  NASC02 = 'NASC02',
  NASC03 = 'NASC03',
  NASC04 = 'NASC04',
  NASC05 = 'NASC05',
  NASC06 = 'NASC06',
  NASC07 = 'NASC07',
  NASC99 = 'NASC99',
  SANIT01 = 'SANIT01',
  PROCUR01 = 'PROCUR01',
  RIC1 = 'RIC_1',
  RIC2 = 'RIC_2',
  RIC3 = 'RIC_3',
  RIC4 = 'RIC_4',
  RIC5 = 'RIC_5',
  RIC6 = 'RIC_6',
  RIC7 = 'RIC_7',
  TRDATIATAU = 'TRDATIATAU',
  TRDATIATIN = 'TRDATIATIN',
  ATCOBASE = 'ATCOBASE',
  ATCOBASEN = 'ATCOBASEN',
  RACTOD343 = 'RACTOD343',
  RACTOD344 = 'RACTOD344',
  RACTOD341 = 'RACTOD341',
  RACTOD441 = 'RACTOD441',
  RACTOD350 = 'RACTOD350',
  RACTOD0216 = 'RACTOD0216',
  RACTOD0103 = 'RACTOD0103',
  ATCOBASED = 'ATCOBASED',
  ATCOBASEDN = 'ATCOBASEDN',
  ATCOBASEC = 'ATCOBASEC',
  ATCOFA = 'ATCOFA',
  ATCOFAN = 'ATCOFAN',
  ATCOBASECP = 'ATCOBASECP',
  RICATTCONS = 'RICATTCONS',
  RICSECONS = 'RICSECONS',
  COMPLIB01 = 'COMPLIB01',
  COMPLIB02 = 'COMPLIB02',
  COMPLIB03 = 'COMPLIB03',
  DICHNNOCON = 'DICHNNOCON',
  RICGENIT = 'RICGENIT',
  SENPROCREP = 'SENPROCREP',
  CONIOPFI = 'CONIOPFI',
  MORDATIAU = 'MORDATIAU',
  PROVCOM = 'PROVCOM',
  DATIDECEST = 'DATIDECEST',
  DATIDECGEN = 'DATIDECGEN',
  DSCIT = 'DSCIT',
  DSCIT2 = 'DSCIT2',
  DSCIT3 = 'DSCIT3',
  DSCIT4 = 'DSCIT4',
  // DSCIT5 = 'DSCIT5',
  DSCIT6 = 'DSCIT6',
  DSCIT7 = 'DSCIT7',
  DSCIT8 = 'DSCIT8',
  DSCIT9 = 'DSCIT9',
  DSCIT10 = 'DSCIT10',
  DSCITFR = 'DSCITFR',
  TRATXBASS = 'TRATXBASS',
  TRATXBASC = 'TRATXBASC',
  TRATXBASD = 'TRATXBASD',
  TRATXBASQ = 'TRATXBASQ',
  DPIMP = 'DPIMP',
  INTCIT = 'INTCIT',
  INTCIT2 = 'INTCIT2',
  INTCIT3 = 'INTCIT3',
  INTCIT4 = 'INTCIT4',
  CSAD = 'CSAD',
  CSRA = 'CSRA',
  DPSM = 'DPSM',
  DGRECUP = 'DGRECUP',
  DGRECUP1 = 'DGRECUP1',
  DGRECUP2 = 'DGRECUP2',
  ENTEDICH = 'ENTEDICH',
  ENTEDICHS = 'ENTEDICHS',
  ENTEDICHT = 'ENTEDICHT',
  ENTEDICHC = 'ENTEDICHC',
  ENTEDICHE = 'ENTEDICHE',
  GTRSCIT = 'GTRSCIT',
  GTRSCIT2 = 'GTRSCIT2',
  ESIACSI = 'ESIACSI',
  ESIACSI2 = 'ESIACSI2',
  GIURCIT = 'GIURCIT',
  GIURCIT2 = 'GIURCIT2',
  ULT_LUOGO = 'ULT_LUOGO',
  DSNAS01 = 'DSNAS01',
  DSNAS02 = 'DSNAS02',
  DSNAS03 = 'DSNAS03',
  DSNAS04 = 'DSNAS04',
  DSNAS05 = 'DSNAS05',
  ANNCONT = 'ANNCONT',
  ANNCONT105 = 'ANNCONT105',
  ANNCONT312 = 'ANNCONT312',
  MADTSP = 'MADTSP',
  MADTSP2 = 'MADTSP2',
  MADTSP3 = 'MADTSP3',
  MADTSP4 = 'MADTSP4',
  MADTSP5 = 'MADTSP5',
  MADTSP6 = 'MADTSP6',
  MADTSP7 = 'MADTSP7',
  MADTSP8 = 'MADTSP8',
  MADTSP9 = 'MADTSP9',
  UCDTSP = 'UCDTSP',
  UCDTSP02 = 'UCDTSP02',
  UCDTSP03 = 'UCDTSP03',
  UCDTSP04 = 'UCDTSP04',
  UCDTSP05 = 'UCDTSP05',
  UCDTSP06 = 'UCDTSP06',
  CERTIF01 = 'CERTIF01',
  ENTEDICHIF = 'ENTEDICHIF',
  ENTEDICHIT = 'ENTEDICHIT',
  ENTEDICHIN = 'ENTEDICHIN',
  ENTEDICHA = 'ENTEDICHA',
  ENTEDICHNC = 'ENTEDICHNC',
  IMPGEN = 'IMPGEN',
  IMPED01 = 'IMPED01',
  IMPED02 = 'IMPED02',
  REGPAT01 = 'REGPAT01',
  REGPAT02 = 'REGPAT02',
  OFFI_CIV = 'OFFI_CIV',
  OFFI_CITT = 'OFFI_CITT',
  OFFI_REL = 'OFFI_REL',
  OFFI_TRAS = 'OFFI_TRAS',
  OFFI_ACATT = 'OFFI_ACATT',
  SEGR_CIV = 'SEGR_CIV',
  PERIC_CIV = 'PERIC_CIV',
  COMSCIO = 'COMSCIO',
  PUBBLI = 'PUBBLI',
  PUBBLIDUE = 'PUBBLIDUE',
  SEPAR01 = 'SEPAR01',
  SEPAR02 = 'SEPAR02',
  SEPAR03 = 'SEPAR03',
  SEPAR04 = 'SEPAR04',
  SEPAR08 = 'SEPAR08',
  UCDTSU01 = 'UCDTSU01',
  UCDTSU02 = 'UCDTSU02',
  UCDTSU03 = 'UCDTSU03',
  NEGOZ1 = 'NEGOZ1',
  NEGOZ2 = 'NEGOZ2',
  INTEGRAZ01 = 'INTEGRAZ01',
  RICONC = 'RICONC',
  FONTEPUBBL = 'FONTEPUBBL',
  ASSFIG = 'ASSFIG',
  RICPOST = 'RICPOST',
  CITLEG = 'CITLEG',
  NEOSNOINT = 'NEOSNOINT',
  NEOSNOINTP = 'NEOSNOINTP',
  NEOSPOS = 'NEOSPOS',
  FGIGN = 'FGIGN',
  ATCODRM = 'ATCODRM',
  ATCODRMA = 'ATCODRMA',
  ATCODRMM = 'ATCODRMM',
  ATCODRMU = 'ATCODRMU',
  DTGANNMO = 'DTGANNMO',
  ASSRESO = 'ASSRESO',
  OFFI_TRASA = 'OFFI_TRASA',
}
